import React from 'react';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CalendarProps } from './types';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import StaticDatePicker from '@mui/lab/StaticDatePicker';
import { Badge, TextField } from '@mui/material';
import PickersDay from '@mui/lab/PickersDay/PickersDay';

const Calendar: React.FC<CalendarProps> = (props) => {
    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <StaticDatePicker
                    autoFocus
                    value={props.value}
                    minDate={props.availableDates.startTime}
                    maxDate={props.availableDates.endTime}
                    onChange={props.onChange}
                    onMonthChange={props.onMonthChange}
                    onYearChange={props.onMonthChange}
                    renderInput={(params) => <TextField {...params} />}
                    renderDay={(day, _value, DayComponentProps) => {
                        const isSelected =
                            props.emphasizedDates.includes(day.getDate()) && day.getMonth() + 1 == props.month;

                        if (!isSelected) {
                            return <PickersDay {...DayComponentProps} />;
                        }

                        return (
                            <Badge key={DayComponentProps.key} color={'success'} variant="dot" overlap="circular">
                                <PickersDay {...DayComponentProps} />
                            </Badge>
                        );
                    }}
                />
            </LocalizationProvider>
        </>
    );
};

export default Calendar;
